import { SecurityModel } from 'api';
import { OptionType } from 'components/CustomSelect/types';
import { CellValue } from 'models/interfaces/spreadsheet-types/core-types';
import { toString } from 'utilities';

export const withFundOwnershipSecurityDisplayFallback = (
  options: OptionType[] | undefined,
  securityId: CellValue,
  captableSecurities: SecurityModel[] | undefined
): OptionType[] => {
  const selectableOptions = options ?? [];

  if (toString(securityId) === '') {
    return selectableOptions;
  }

  const securityIdString = toString(securityId);
  if (selectableOptions.some(option => toString(option.value) === securityIdString)) {
    return selectableOptions;
  }

  const matchedSecurity = captableSecurities?.find(security => toString(security.id) === securityIdString);
  if (!matchedSecurity?.name || matchedSecurity.name === '') {
    return selectableOptions;
  }

  return [
    ...selectableOptions,
    {
      label: matchedSecurity?.name ?? '',
      value: securityIdString,
      id: securityIdString,
    },
  ];
};
